<template>
<md-list-item>
    <md-avatar v-if="collabUser">
        <img :src="collabUser.profile_picture" alt="People" v-if="collabUser.profile_picture" />
        <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People" />
    </md-avatar>
    <div v-if="collabUser" class="md-list-text-container collaborator-text-container">
        <span><strong>{{collabUser.username}}</strong></span>
        <span v-if="collaborator.role">{{collaborator.role}}</span>
        <span>{{collabUser.email}}</span>
    </div>
    <md-list-expand>
        <md-layout class="heading-align" md-align="center" >
            <md-layout md-flex="90">
                <h2 class="md-title">Layer Permissions</h2>
            </md-layout>
        </md-layout>
        <md-list class="sub-list" >
            <md-list-item>
                <md-layout md-row>
                    <md-layout md-flex="25"><label>Edit</label></md-layout>
                </md-layout>
                <span>Layer Name</span>
            </md-list-item>
            <md-list class="sub-list">
                <layer-permission v-for="layer in layers" :key="layer.id"
                    :layer="layer"
                    :editable="editable"
                    :collaborator="collaborator"/>
            </md-list>
        </md-list>
        <md-button @click="removeCollaborator" v-if="user.uid === collaborator.uid || editable">
            <md-icon>delete</md-icon>
            Remove From Project
        </md-button>
    </md-list-expand>
</md-list-item>
</template>

<script>
import CollaboratorsLayerPermission from '@/components/collaborators/layer-permission';

const CollaboratorsCollaborator = {
    name: 'CollaboratorsCollaborator',
    props: ['collaborator', 'user', 'collabUser', 'editable', 'layers'],
    components: {
        layerPermission: CollaboratorsLayerPermission
    },
    data: function() {
        return {
            editing: false
        };
    },
    methods: {
        removeCollaborator() {
            this.$emit('removeCollaborator', this.collaborator.uid);
        }
    },
    mounted: function() {
        console.log(this.user.uid);
        console.log(this.collaborator.uid);
        console.log(this.editable);
    }
};
export default CollaboratorsCollaborator;
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// collaborator.vue?2bee069d